import * as uuid from 'uuid';

import analytics, {
  EventTypeElementImpression,
  EventTypeElementInteracted,
} from '@nerdwallet/analytics';

export const trackImpression = ({
  entityName,
  sectionName,
  registrationCohort,
  payload,
}: {
  entityName: EventTypeElementImpression['Payload']['entity_name'];
  sectionName?: EventTypeElementImpression['Payload']['section_name'];
  registrationCohort?: EventTypeElementImpression['Payload']['registration_cohort'];
  payload?: Record<string, unknown>;
}): void => {
  analytics.track<EventTypeElementImpression>('element_impression', {
    entity_name: entityName,
    section_name: sectionName,
    registration_cohort: registrationCohort,
    ...payload,
  });
};

export const trackInteraction = ({
  entityName,
  action,
  sectionName,
  registrationCohort,
}: {
  entityName: EventTypeElementInteracted['Payload']['entity_name'];
  action: EventTypeElementInteracted['Payload']['action'];
  sectionName?: EventTypeElementInteracted['Payload']['section_name'];
  registrationCohort?: EventTypeElementInteracted['Payload']['registration_cohort'];
}): void => {
  analytics.track<EventTypeElementInteracted>('element_interacted', {
    entity_name: entityName,
    section_name: sectionName,
    action,
    registration_cohort: registrationCohort,
    interaction_id: uuid.v4(),
    interaction_type: 'press',
  });
};

// from https://github.com/NerdWallet/mobile-creditcards/blob/4065e2d172f13ea625bc2cbfeeedf5da4b05fe4e/App/Lib/error-utils.ts#L30
export const getStackTrace = (error: any) => {
  const stackTrace = error?.stack;
  if (!stackTrace) return undefined;
  return stackTrace.split('\n');
};

export const trackError = (error: any) => {
  const { name, code, message } = error;
  analytics.track('error_occurred', {
    error_name: name,
    error_code: code,
    error_message: message,
    stack_trace: getStackTrace(error),
  });
};

export const getJiraTicketIdentifier = ({
  identifier,
}: {
  identifier: string;
}): string => {
  // Since both dashes and underscores are valid, split by both at once
  const splidIdentifier = identifier.split(/[-_]/);
  return splidIdentifier.slice(0, 2).join('-');
};

export const trackPasswordRegisteredUserEvent = (
  identifier: string,
  trackHook: (eventKey: string, userAttributes?: Record<string, any>) => any
): void => {
  trackHook(`${getJiraTicketIdentifier({ identifier })}_registration`);
};
